export const FREE_EMAIL_DOMAINS = [
  { label: 'Gmail', domain: 'gmail.com', checkedByDefault: true },
  { label: 'Yahoo', domain: 'yahoo.com', checkedByDefault: true },
  { label: 'Hotmail', domain: 'hotmail.com', checkedByDefault: false },
  { label: 'Outlook', domain: 'outlook.com', checkedByDefault: true },
  { label: 'iCloud', domain: 'icloud.com', checkedByDefault: true },
  { label: 'AOL', domain: 'aol.com', checkedByDefault: false },
  { label: 'Proton Mail', domain: 'protonmail.com', checkedByDefault: true },
  { label: 'GMX', domain: 'gmx.com', checkedByDefault: true },
]

export const DEFAULT_BLOCKED_DOMAINS = FREE_EMAIL_DOMAINS
  .filter((freeDomain) => freeDomain.checkedByDefault)
  .map((freeDomain) => freeDomain.domain)

// Broader, less common free providers grouped behind the "Other free providers" checkbox
export const OTHER_FREE_EMAIL_DOMAINS = [
  'mail.com',
  'zoho.com',
  'yandex.com',
  'live.com',
  'msn.com',
  'comcast.net',
  'mail.ru',
  'inbox.com',
]
